import { render, staticRenderFns } from "./PatientRequests.vue?vue&type=template&id=7b756aba&scoped=true"
import script from "./PatientRequests.vue?vue&type=script&lang=js"
export * from "./PatientRequests.vue?vue&type=script&lang=js"
import style0 from "./PatientRequests.vue?vue&type=style&index=0&id=7b756aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b756aba",
  null
  
)

export default component.exports